import type { EstadoPaquete } from '@condo/contracts';
import { Badge } from '@/components/ui/badge.js';

const LABEL: Record<EstadoPaquete, string> = {
  recibido: 'Recibido',
  retirado: 'Retirado',
  devuelto: 'Devuelto',
  anulado: 'Anulado',
};

const VARIANT: Record<EstadoPaquete, 'warning' | 'success' | 'danger' | 'neutral'> = {
  recibido: 'warning',
  retirado: 'success',
  devuelto: 'danger',
  anulado: 'neutral',
};

export function EstadoPaqueteBadge({ estado }: { estado: EstadoPaquete }) {
  return <Badge variant={VARIANT[estado]}>{LABEL[estado]}</Badge>;
}
